import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { useApolloClient } from '@apollo/client';

import { pick } from 'lodash';
import { ListingItem } from 'app/components/RichList/items/ListingItem';

import USER_QUERY from 'gql/queries/currentUser.gql';

export default function Preview() {
  const client = useApolloClient();
  const data = client.readQuery({ query: USER_QUERY });
  const { values }: any = useFormikContext();

  const listing = {
    ...values,
    author: pick(data.currentUser, ['id', 'firstName', 'lastName', 'email'])
  };

  return (
    <Grid container justifyContent="center">
      <ListingItem listing={listing} noOpen preview />
    </Grid>
  );
}
